import VideoRecorder from "react-video-recorder";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Grid, Typography, List, ListItem, ListItemText } from "@mui/material";

import pages from "../../constants/pages";
import { OuterBox, LoadingButton, SubheaderSection } from "./../../components";

export default function UploadDocument() {
  //const classes = useStyles();
  const navigate = useNavigate();
  const [mimeType, setMimeType] = useState("video/webm;codecs=vp8,opus");

  useEffect(() => {
    if (window.navigator.userAgent.indexOf("Windows") !== -1) {
      setMimeType("video/webm;codecs=vp8,opus");
    } else if (window.navigator.userAgent.indexOf("Mac OS") !== -1) {
      setMimeType("video/mp4");
    } else if (window.navigator.userAgent.indexOf("Linux") !== -1) {
      setMimeType("video/webm;codecs=vp8,opus");
    } else {
      setMimeType("video/webm;codecs=vp8,opus");
    }
  }, []);

  const [startRecording, setStartRecording] = useState(false);

  //const userDetails = useSelector((state) => state.userIdentityDetails);

  const location = useLocation();
  const { visitor_id } = location.state || {};
  const verificationContent = startRecording
    ? ""
    : "Next, Please read the following guidelines then proceed to Liveness Check:";

  return (
    <OuterBox>
      <SubheaderSection
        textAlign="left"
        title="Document Verification Successful"
        content={verificationContent}
      />

      <form>
        {/* <Grid container spacing={4}> */}
        {!startRecording ? (
          <React.Fragment>
            <div>
              <div>
                <List>
                  <ListItem sx={{ padding: "2px" }}>
                    <CheckCircleOutlineIcon
                      sx={{ color: "#4CAF50", marginRight: "10px" }}
                    />

                    <ListItemText primary="Allow access to camera, microphone and location." />
                  </ListItem>

                  <ListItem sx={{ padding: "2px" }}>
                    <CheckCircleOutlineIcon
                      sx={{ color: "#4CAF50", marginRight: "10px" }}
                    />

                    <ListItemText primary="Make sure to have a stable Internet connection." />
                  </ListItem>
                  <ListItem sx={{ padding: "2px" }}>
                    <CheckCircleOutlineIcon
                      sx={{ color: "#4CAF50", marginRight: "10px" }}
                    />

                    <ListItemText primary="Ensure proper lighting." />
                  </ListItem>
                  <ListItem sx={{ padding: "2px" }}>
                    <CheckCircleOutlineIcon
                      sx={{ color: "#4CAF50", marginRight: "10px" }}
                    />

                    <ListItemText primary="Face the camera directly." />
                  </ListItem>
                  <ListItem sx={{ padding: "2px" }}>
                    <CheckCircleOutlineIcon
                      sx={{ color: "#4CAF50", marginRight: "10px" }}
                    />

                    <ListItemText primary="Do not use a photo or video." />
                  </ListItem>

                  <ListItem sx={{ padding: "2px" }}>
                    <CheckCircleOutlineIcon
                      sx={{ color: "#4CAF50", marginRight: "10px" }}
                    />

                    <ListItemText primary="Verify that the camera frame contains only one face." />
                  </ListItem>

                  <ListItem sx={{ padding: "2px" }}>
                    <CheckCircleOutlineIcon
                      sx={{ color: "#4CAF50", marginRight: "10px" }}
                    />

                    <ListItemText primary="Keep still and blink frequently." />
                  </ListItem>
                </List>
              </div>
            </div>
            <LoadingButton onClick={() => setStartRecording(true)}>
              Launch Camera
            </LoadingButton>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Grid item xs={12}>
              <VideoRecorder
                isOnInitially
                countdownTime={0}
                timeLimit={7000}
                mimeType={mimeType}
                renderVideoInputView={({ videoInput }) => <>{videoInput}</>}
                constraints={{
                  audio: true,
                  video: {
                    width: { exact: 480, ideal: 480 },
                    height: { exact: 700, ideal: 700 },
                    aspectRatio: {
                      exact: 0.7500000001,
                      ideal: 0.7500000001,
                    },
                  },
                }}
                onRecordingComplete={(videoBlob) => {
                  navigate(pages.previewVideo.route, {
                    state: {
                      blob: videoBlob,
                      visitor_id: visitor_id,
                    },
                  });
                }}
              />
            </Grid>

            <Typography
              variant="body2"
              gutterBottom
              sx={{ textAlign: "center", padding: "10px" }}
              fontWeight="bold"
            >
              Make sure to play and verify the video before submitting
            </Typography>
          </React.Fragment>
        )}
      </form>
    </OuterBox>
  );
}
